module.exports = __webpack_public_path__ + "img/28_62.ad7d36b9.png";